import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { RouteReuseStrategy } from '@angular/router'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http' // HttpClientModule and HTTP_INTERCEPTORS
import { IonicModule, IonicRouteStrategy } from '@ionic/angular'

import { MySharedService } from './helpers/MySharedService'
import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { httpConfig } from './helpers/httpConfig'
import { SocialSharing } from '@ionic-native/social-sharing/ngx'
import { TokenInterceptor } from './helpers/token.interceptor'
import { BusinessCardModule } from './reusable-components/business-card/business-card.module'
import { LoadingScreenModule } from './reusable-components/loading-screen/loading-screen.module'

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule, // This ensures you can make HTTP requests
    BusinessCardModule,
    LoadingScreenModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor, // Your interceptor to handle JWT token
      multi: true, // Important for adding multiple interceptors if needed
    },
    MySharedService,
    httpConfig,
    SocialSharing,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
